import React from 'react';

// Tabs Component
export const Tabs = ({ children, defaultValue, value, onValueChange, className = '' }) => {
  const [activeTab, setActiveTab] = React.useState(defaultValue || value);

  React.useEffect(() => {
    if (value !== undefined) {
      setActiveTab(value);
    }
  }, [value]);

  const handleTabChange = (newValue) => {
    if (value === undefined) {
      setActiveTab(newValue);
    }
    if (onValueChange) {
      onValueChange(newValue);
    }
  };

  return (
    <div className={className}>
      {React.Children.map(children, child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, { activeTab, onTabChange: handleTabChange });
        }
        return child;
      })}
    </div>
  );
};

export const TabsList = ({ children, className = '', activeTab, onTabChange }) => {
  return (
    <div className={`flex space-x-1 bg-gray-100 p-1 rounded-lg ${className}`}>
      {React.Children.map(children, child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, { activeTab, onTabChange });
        }
        return child;
      })}
    </div>
  );
};

export const TabsTrigger = ({ children, value, className = '', activeTab, onTabChange }) => {
  const isActive = activeTab === value;
  
  return (
    <button
      onClick={() => onTabChange && onTabChange(value)}
      className={`
        px-3 py-2 text-sm font-medium rounded-md transition-all
        ${isActive 
          ? 'bg-white shadow text-gray-900' 
          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
        }
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      {children}
    </button>
  );
};

export const TabsContent = ({ children, value, className = '', activeTab }) => {
  if (activeTab !== value) return null;
  
  return (
    <div className={`mt-4 ${className}`}>
      {children}
    </div>
  );
};